const SidebarPropsMixin = {
  props: {
    titlePadding: {
      type: String,
      required: false,
      default: 'pl-12'
    },
    listPadding: {
      type: String,
      required: false,
      default: 'pl-14'
    },
    searchPadding: {
      type: String,
      required: false,
      default: 'pl-16'
    }
  }

}

export default SidebarPropsMixin
